import _toConsumableArray from '/home/ubuntu/BookingSystemV2/node_modules/babel-runtime/helpers/toConsumableArray';
import _Set from '/home/ubuntu/BookingSystemV2/node_modules/babel-runtime/core-js/set';
import _getIterator from '/home/ubuntu/BookingSystemV2/node_modules/babel-runtime/core-js/get-iterator';
import _extends from '/home/ubuntu/BookingSystemV2/node_modules/babel-runtime/helpers/extends';
import _regeneratorRuntime from '/home/ubuntu/BookingSystemV2/node_modules/babel-runtime/regenerator';
import _asyncToGenerator from '/home/ubuntu/BookingSystemV2/node_modules/babel-runtime/helpers/asyncToGenerator';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/*
* plugins
* */
import axios from '~/plugins/axios';

/*
* components
* */
import addApplicant from '~/components/mainPage/bookModuleSession/AddApplicant.vue';
import msList from '~/static/moduleName.json';

export default {
    name: "combo-book",
    components: {
        addApplicant: addApplicant

    },

    data: function data() {
        return {
            sel: false,
            mark: "this is combo book index.vue page",
            // modal symbol
            showBookModal: false,
            showChangeMsModal: false,
            // current msList
            changeMsList: null,
            // selecting ms
            oldMs: null,
            newMs: null,
            fields: {
                fullName: {
                    label: "Name",
                    key: "fullname"
                },
                nricFin: {
                    label: "NRIC/FIN",
                    key: "nricFin"
                },
                companyName: {
                    label: "Company",
                    key: "companyName"
                },
                workPermitNo: {
                    label: "WP No.",
                    key: "workingProfile.Work_Permit_number"
                },
                workForceCategory: {
                    label: "WorkForce Cat.",
                    key: "workingProfile.workforce_category"
                },
                designation: {
                    label: "designation",
                    key: "workingProfile.Designation"
                },
                moduleSessionList: {
                    label: " ----- Module ----- "
                },
                action: {
                    label: "Action"
                }

            },

            newApplicantList: [],

            selectedMsList: [],

            applicant: {
                id: '',
                fullname: '',
                nricFin: '',
                companyName: '',
                selected: [],
                suggested: []
            },
            /**
             * this is all options for the module booking
             */
            msList: msList
            /*
              [
                {msName: 'JSA', value:'JSA'},
                {msName: 'SIC-IFW', value:'SIC-IFW'},
                {msName: 'SSK', value:'SSK'},
                {msName: 'SIFAPP_1_-_WAH', value:'SIFAPP_1_-_WAH'},
                {msName: 'SIFAPP_2_-_OTHERS', value:'SIFAPP_2_-_OTHERS'},
                {msName: 'ePTW', value:'ePTW'},
                {msName: 'Traf_Contr_Banksman', value:'Traf_Contr_Banksman'},
                {msName: 'Fire_Watchman', value:'Fire_Watchman'},
              ]
              */
        };
    },
    fetch: function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
            var store = _ref.store,
                redirect = _ref.redirect;
            return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            if (store.state.authUser) {
                                _context.next = 2;
                                break;
                            }

                            return _context.abrupt('return', redirect('/'));

                        case 2:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function fetch(_x) {
            return _ref2.apply(this, arguments);
        }

        return fetch;
    }(),


    methods: {
        /*
        * add Combo booking user to the table
        * */
        addComboUser: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(nricFin) {
                var newApplicant;
                return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                console.log('\n\n=========comboBook.index.vue <|-- nricFin=======', nricFin, '\n------------------------');
                                _context2.next = 3;
                                return axios.post("/users/nricFin", { nricFin: nricFin });

                            case 3:
                                newApplicant = _context2.sent.data;


                                console.log('\n\n=========comboBook.index.vue <|-- newApplicant=======', newApplicant, '\n------------------------');

                                if (newApplicant.isActivated !== true) {
                                    alert('Applicant has not been approved yet');
                                } else {
                                    newApplicant = _extends({}, newApplicant, {
                                        bookingDone: false,
                                        selected: [],
                                        suggested: [] });
                                    console.log('\n\n=========comboBook.index.vue <|-- newApplicant', newApplicant, '\n------------');

                                    newApplicant.hasOwnProperty("nricFin") ? this.newApplicantList.push(newApplicant) : alert(newApplicant);
                                }

                            case 6:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function addComboUser(_x2) {
                return _ref3.apply(this, arguments);
            }

            return addComboUser;
        }(),


        /*
        * pop up booking modal for combo booking
        * */
        popUpBookingModal: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
                var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.applicant;
                var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                var target = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

                var id, fullname, nricFin, companyName, selected, preRequisite, tempSugg, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, msName, suggestion;

                return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:

                                console.log('\n\n========= comboBook.popModal <|-- item ========\n', item, '\n------------------');
                                console.log('\n\n========= comboBook.popModal <|-- index ========\n', index, '\n------------------');
                                console.log('\n\n========= comboBook.popModal <|-- target ========\n', target, '\n------------------');
                                console.log('\n\n========= comboBook.popModal <|-- newApplicant ========\n', this.newApplicantList[index].selected, '\n------------------');

                                id = item.id, fullname = item.fullname, nricFin = item.nricFin, companyName = item.companyName, selected = item.selected;


                                this.applicant.id = id;
                                this.applicant.fullname = fullname;
                                this.applicant.nricFin = nricFin;
                                this.applicant.companyName = companyName;
                                this.applicant.selected = selected;

                                preRequisite = this.preRequisite(selected); //

                                console.log('\n\n =========== comboBook.popModal <|-- this.applicant ==========\n', this.applicant, '\n--------------------------');

                                tempSugg = [];
                                _iteratorNormalCompletion = true;
                                _didIteratorError = false;
                                _iteratorError = undefined;
                                _context3.prev = 16;
                                _iterator = _getIterator(selected);

                            case 18:
                                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                                    _context3.next = 28;
                                    break;
                                }

                                msName = _step.value;
                                _context3.next = 22;
                                return this.getModuleSession(msName, preRequisite, id);

                            case 22:
                                suggestion = _context3.sent;
                                // TODO -> just added

                                console.log('\n\n =========== comboBook.popModal <|-- no valid modulesession suggested ==========\n', suggestion, '\n--------------------------');

                                !!suggestion ? tempSugg.push(suggestion) : tempSugg.push({ moduleName: 'Currently no suggestions for -> ' + msName });

                                //   tempSugg.push(suggestion);


                            case 25:
                                _iteratorNormalCompletion = true;
                                _context3.next = 18;
                                break;

                            case 28:
                                _context3.next = 34;
                                break;

                            case 30:
                                _context3.prev = 30;
                                _context3.t0 = _context3['catch'](16);
                                _didIteratorError = true;
                                _iteratorError = _context3.t0;

                            case 34:
                                _context3.prev = 34;
                                _context3.prev = 35;

                                if (!_iteratorNormalCompletion && _iterator.return) {
                                    _iterator.return();
                                }

                            case 37:
                                _context3.prev = 37;

                                if (!_didIteratorError) {
                                    _context3.next = 40;
                                    break;
                                }

                                throw _iteratorError;

                            case 40:
                                return _context3.finish(37);

                            case 41:
                                return _context3.finish(34);

                            case 42:

                                this.applicant.suggested = tempSugg;

                                console.log('\n =========== comboBook.popModal <|-- After Suggestion ==========\n');

                                this.showBookModal = true;

                            case 45:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this, [[16, 30, 34, 42], [35,, 37, 41]]);
            }));

            function popUpBookingModal() {
                return _ref4.apply(this, arguments);
            }

            return popUpBookingModal;
        }(),


        /*
        * close booking modal
        * */
        hideBookModal: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
                return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                this.showBookModal = false;
                                // this.applicant = {
                                //     fullname: '',
                                //     nricFin: '',
                                //     companyName: '',
                                //     selected: []
                                // };
                                console.log('\n\n=========== comboBook.hideBookModal ==========\n');

                            case 2:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function hideBookModal() {
                return _ref5.apply(this, arguments);
            }

            return hideBookModal;
        }(),


        /*
        * check module session and select
        * */
        getModuleSession: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(moduleName, preRequisite, userActorId) {
                var suggestion;
                return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return axios.post('/moduleSession/randomSuggestion', { moduleName: moduleName, preRequisite: preRequisite, userActorId: userActorId });

                            case 2:
                                suggestion = _context5.sent.data;

                                console.log('\n\n========= comboBook.popModal <|-- suggestion ========== \n', suggestion, '\n ---------------------------');
                                console.log('\n\n======= comboBook <| -- getMsName ====== \n', moduleName, '\n ------------');

                                return _context5.abrupt('return', suggestion);

                            case 6:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function getModuleSession(_x6, _x7, _x8) {
                return _ref6.apply(this, arguments);
            }

            return getModuleSession;
        }(),


        /*
        * book selected module
        * */
        bookSelectedModuleSession: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
                var _this, xx, infoReturned;

                return _regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _this = this;


                                console.log('\n\n========= comboBook.bookSelectedModuleSession <|-- applicantID', this.applicant.id, '\n -------------------------');

                                console.log('\n\n========= comboBook.bookSelectedModuleSession <|-- msArr ========== \n', this.applicant.suggested, '\n ---------------------------');

                                console.log('\n\n========= comboBook.bookSelectedModuleSession <|-- newApplicantList ========== \n', this.newApplicantList, '\n ---------------------------');

                                // this.newApplicantList[this.newApplicantList
                                //     .findIndex(applicant=> {applicant.id === this.applicant.id})]
                                //     .bookingDone = true;
                                xx = this.newApplicantList.find(function (app) {
                                    return app.nricFin === _this.applicant.nricFin;
                                });


                                console.log('\n\n========= comboBook.bookSelectedModuleSession <|-- xx ========== \n', xx, '\n ---------------------------');

                                xx.bookingDone = true;

                                _context6.next = 9;
                                return axios.post('/userMsManager/comboBooking', { userActor: this.applicant });

                            case 9:
                                infoReturned = _context6.sent.data;


                                console.log('\n\n=========== comboBook.bookSelectedModuleSession <|-- infoReturned ==========\n', infoReturned, '\n --------------------------');

                                this.hideBookModal();

                            case 12:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function bookSelectedModuleSession() {
                return _ref7.apply(this, arguments);
            }

            return bookSelectedModuleSession;
        }(),


        /**
         * change date ms modal
         */
        changeSuggestedData: function () {
            var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(item) {
                var moduleName, changeMsList;
                return _regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                this.showBookModal = false;
                                this.showChangeMsModal = true;

                                this.oldMs = item;

                                // console.log('item', item);

                                moduleName = item.moduleName;
                                _context7.next = 6;
                                return axios.post('/moduleSession/byModuleSessionName', { moduleName: moduleName, mark: 'combo' });

                            case 6:
                                changeMsList = _context7.sent.data;


                                console.log('returnInfo', changeMsList);

                                this.changeMsList = changeMsList;

                            case 9:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function changeSuggestedData(_x9) {
                return _ref8.apply(this, arguments);
            }

            return changeSuggestedData;
        }(),

        /**
         * hide change ms modal
         */
        hideChangeMsModal: function () {
            var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
                var tempSet;
                return _regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                tempSet = new _Set(this.applicant.suggested);

                                tempSet.delete(this.oldMs);
                                this.applicant.suggested = [].concat(_toConsumableArray(tempSet));
                                this.applicant.suggested.push(this.newMs.hasOwnProperty('moduleName') ? this.newMs : this.oldMs);

                                this.showChangeMsModal = false;
                                this.showBookModal = true;

                                // console.log(
                                //     'changeMsList',this.changeMsList,
                                //     '\noldMs',this.oldMs,
                                //     '\nnewMs',this.newMs,
                                //     '\nselectMsList',this.selectedMsList
                                // );

                            case 6:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, this);
            }));

            function hideChangeMsModal() {
                return _ref9.apply(this, arguments);
            }

            return hideChangeMsModal;
        }(),

        /**
         * change one selection
         */
        selectOtherMs: function () {
            var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(item) {
                return _regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                this.newMs = item;
                                // await this.hideChangeMsModal();

                            case 1:
                            case 'end':
                                return _context9.stop();
                        }
                    }
                }, _callee9, this);
            }));

            function selectOtherMs(_x10) {
                return _ref10.apply(this, arguments);
            }

            return selectOtherMs;
        }(),


        /**
         * front-end verify if preRequisite
         */
        preRequisite: function preRequisite(selected) {
            var hasSICIFW = void 0,
                hasJSA = void 0;

            hasSICIFW = !!selected.find(function (sl) {
                return sl.match(/^ifwo\/sic/ig);
            });

            hasJSA = !!selected.find(function (sl) {
                return sl.match(/^jsa/ig);
            });

            return { hasSICIFW: hasSICIFW, hasJSA: hasJSA };
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/home/ubuntu/BookingSystemV2/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/comboBook/index.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/home/ubuntu/BookingSystemV2/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/comboBook/index.vue
// module chunks = 13